import Vue from 'vue';
import { Module } from 'vuex';
import { RootState } from '@/types/store';
import { User } from '@sentry/browser';

export interface CoinState {
    info: Coin.Info | null;
    detail: {
        all: ListWrap<Coin.Detail> & ListRequesting;
        coin: ListWrap<Coin.Detail> & ListRequesting;
        user: ListWrap<Coin.Detail> & ListRequesting;
        you_zan: ListWrap<Coin.Detail> & ListRequesting;
    };
    integral: {
        all: ListWrap<Coin.Detail> & ListRequesting;
        income: ListWrap<Coin.Detail> & ListRequesting;
        expend: ListWrap<Coin.Detail> & ListRequesting;
    };
}

const m: Module<CoinState, RootState> = {
    namespaced: true,
    state: {
        info: null,
        detail: {
            all: { list: [], loaded: false, requesting: false },
            coin: { list: [], loaded: false, requesting: false },
            user: { list: [], loaded: false, requesting: false },
            you_zan: { list: [], loaded: false, requesting: false },
        },
        integral: {
            all: { list: [], loaded: false, requesting: false },
            income: { list: [], loaded: false, requesting: false },
            expend: { list: [], loaded: false, requesting: false },
        },
    },
    mutations: {
        setInfo(state, info) {
            state.info = info;
        },
        initDetail(state, { type }: { type: Coin.CoinType }) {
            state.detail[type].list = [];
            state.detail[type].loaded = false;
            state.detail[type].requesting = false;
        },
        concatDetail(state, { type, list }: { type: Coin.CoinType; list: any }) {
            state.detail[type].list = state.detail[type].list.concat(list);
        },
        setDetailLoaded(state, { type, loaded }: { type: Coin.CoinType; loaded: boolean }) {
            state.detail[type].loaded = loaded;
        },
        setDetailReq(state, { type, req }: { type: Coin.CoinType; req: boolean }) {
            state.detail[type].requesting = req;
        },

        initIntegral(state, { type }: { type: Coin.IntegralType }) {
            state.integral[type].list = [];
            state.integral[type].loaded = false;
            state.integral[type].requesting = false;
        },
        concatIntegral(state, { type, list }: { type: Coin.IntegralType; list: any }) {
            state.integral[type].list = state.integral[type].list.concat(list);
        },
        setIntegralLoaded(state, { type, loaded }: { type: Coin.IntegralType; loaded: boolean }) {
            state.integral[type].loaded = loaded;
        },
        setIntegralReq(state, { type, req }: { type: Coin.IntegralType; req: boolean }) {
            state.integral[type].requesting = req;
        },
    },
    actions: {
        async getInfo(context) {
            const response = await Vue.axios.get('/api/v1/coin/info');
            const rdata = response.data;
            if (rdata.status === 0) {
                context.commit('setInfo', rdata.data);
            }
            return rdata;
        },
        async getDetail({ state, commit }, { type, offset, count, forceUpdate }: { type: Coin.CoinType; offset: number; count: number; forceUpdate?: boolean }) {
            let wrap = state.detail[type];
            if (offset === 0 && forceUpdate) {
                commit('initDetail', { type });
                wrap = state.detail[type];
            }
            if (wrap.loaded || wrap.requesting) {
                return;
            }
            const end = offset + count;
            const len = wrap.list.length;
            if (end <= len) {
                return;
            }
            if (offset < len) {
                offset = len;
                count = end - offset;
            }
            commit('setDetailReq', { type, req: true });
            const response = await Vue.axios.get('/api/v1/coin/detail', {
                params: {
                    type: type === 'all' ? undefined : type,
                    offset,
                    count,
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                const list = rdata.data;
                commit('concatDetail', { type, list });
                if (list.length < count) {
                    commit('setDetailLoaded', { type, loaded: true });
                }
            }
            commit('setDetailReq', { type, req: false });
            return rdata;
        },
        /**
         * 提现
         */
        async withdraw({ dispatch }, { count }) {
            const response = await Vue.axios.post('/api/v1/coin/withdraw', {
                count,
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                dispatch('getInfo');
            }
            return rdata;
        },
        /**
         * 更新信息
         */
        async updateInfo({ dispatch }, { name, idNumber, bankCard }) {
            const response = await Vue.axios.post('/api/v1/coin/tax_info', {
                name,
                id_number: idNumber,
                bank_card: bankCard,
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                dispatch('getInfo');
            }
            return rdata;
        },
        /**
         * 赠送
         */
        async give(context, { isFreeze, count, userId, remark }) {
            const response = await Vue.axios.post('/api/v1/coin/give', {
                is_freeze: isFreeze,
                count,
                user_id: userId,
                remark,
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                //
            }
            return rdata;
        },
        /**
         * 获取积分
         */
        async getIntegral({ dispatch }) {
            const response = await Vue.axios.get('/api/v1/integral');
            const rdata = response.data;
            return rdata;
        },
        /**
         * 获取积分数据
         */
        async getIntegralList({ state, commit }, { last_id, count, type, forceUpdate }: { last_id: number; count: number; type: 'all' | 'income' | 'expend', forceUpdate: boolean }) {
            let wrap = state.integral[type];
            if (!last_id && forceUpdate) {
                commit('initIntegral', { type });
                wrap = state.integral[type];
            }
            if (wrap.loaded || wrap.requesting) {
                return;
            }
            const response = await Vue.axios.get('/api/v1/integral/detail', {
                params: {
                    type: type === 'all' ? undefined : type,
                    last_id,
                    count,
                },
            });
            const rdata = response.data;
            // const data = [];
            // for (let i = 0; i < 10; i++) {
            //     data.push({
            //         id: i,
            //         title: 'xxx',
            //         type: i%2 ? 'expend' : 'income',
            //         count: ((i % 2) ? '+' : '-') + '10xxx',
            //         balance: '',
            //     });
            // }
            // const rdata = {
            //     status: 0,
            //     data,
            // };
            if (rdata.status === 0) {
                const list = rdata.data;
                commit('concatIntegral', { type, list });
                if (list.length < count) {
                    commit('setIntegralLoaded', { type, loaded: true });
                }
            }
            commit('setIntegralReq', { type, req: false });
            return rdata;
        },
    },
};

export default m;
